// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '52b6c9bc-20be-4667-9360-873ea0dce124',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: 2,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Island_6',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'CANDY LAND',
        atlas: 'diorama_6',
        reward: {
          'Coin': 100,
          'BoosterHammer': 1,
        }
      }
    },
    {
      id: 'f65cec6a-50d5-4804-93d3-e6fedd8cfd9a',
      type: 'Sprite',
      name: 'candyHouseShadow',
      className: '',
      x: 17,
      y: -393,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Candy_House_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0da23a5c-2582-4b6f-a85f-cc3894185f10',
      type: 'Sprite',
      name: 'candyHouse',
      className: '',
      x: 12,
      y: -463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Candy_House',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 8
      }
    },
    {
      id: '3c41c025-193c-49cb-b5ba-ee9e138ec955',
      type: 'Sprite',
      name: 'towerShadow',
      className: '',
      x: 38,
      y: -203,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Candy_Tower_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '541c1c5c-1d1a-42e5-914d-61e0b81c1e0b',
      type: 'Sprite',
      name: 'tower',
      className: '',
      x: 28,
      y: -229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Candy_Tower',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 6
      }
    },
    {
      id: '346c685d-36dc-4acc-8080-43e436fbb6ba',
      type: 'Sprite',
      name: 'chocoHouseShadow',
      className: '',
      x: 202,
      y: -219,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Choco_House_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'b73f3666-5520-4b14-8a37-c4db36a33112',
      type: 'Sprite',
      name: 'chocoHouse',
      className: '',
      x: 191,
      y: -284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Choco_House',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 3
      }
    },
    {
      id: '287b1df8-1c67-4895-9805-0836bde7acf7',
      type: 'Sprite',
      name: 'cupcakeShadow',
      className: '',
      x: 164,
      y: -409,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Cupcake_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '5da07c2b-afdf-4c8f-ba35-f303a885af8b',
      type: 'Sprite',
      name: 'cupcake',
      className: '',
      x: 155,
      y: -462,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Cupcake',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1500,
        order: 5
      }
    },
    {
      id: '40f23ade-7326-4de9-b1db-896e5ac5a373',
      type: 'Sprite',
      name: 'gingerbreadShadow',
      className: '',
      x: -210,
      y: -185,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Gingerbread_Man_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0199ed88-1a78-4c43-b805-67b6d6560854',
      type: 'Sprite',
      name: 'gingerbread',
      className: '',
      x: -222,
      y: -237,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Gingerbread_Man',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1500,
        order: 2
      }
    },
    {
      id: '5738cfe3-42dd-42f9-bbfe-f2e18d8ea88d',
      type: 'Sprite',
      name: 'lollipopShadow',
      className: '',
      x: -187,
      y: -352,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Lollipop_1_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '79694f9f-2835-4dd6-b940-c6e1fd945c9b',
      type: 'Sprite',
      name: 'lollipop',
      className: '',
      x: -201,
      y: -378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Lollipop_1',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 4
      }
    },
    {
      id: '99a48ee2-b178-4fde-b2f6-b50813e5aecd',
      type: 'Sprite',
      name: 'lollipop2Shadow',
      className: '',
      x: -47,
      y: -317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Lollipop_2_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'ceccc62b-c1a0-4681-b107-3092597ef21b',
      type: 'Sprite',
      name: 'lollipop2',
      className: '',
      x: -56,
      y: -319,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Lollipop_2',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 1
      }
    },
    {
      id: 'e7ba9e77-f3ab-477a-920d-2ce6e6f4834f',
      type: 'Sprite',
      name: 'puddingShadow',
      className: '',
      x: -149,
      y: -175,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Pudding_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '42060b5c-86d9-44db-afab-6dc3da4b2fac',
      type: 'Sprite',
      name: 'pudding',
      className: '',
      x: -154,
      y: -195,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Pudding',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1500,
        order: 7
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_6 {
  static raw = raw;
  root!: Container;
  island!: Sprite & { data: typeof raw['list'][1]['data'] };
  candyHouseShadow!: Sprite;
  candyHouse!: Sprite & { data: typeof raw['list'][3]['data'] };
  towerShadow!: Sprite;
  tower!: Sprite & { data: typeof raw['list'][5]['data'] };
  chocoHouseShadow!: Sprite;
  chocoHouse!: Sprite & { data: typeof raw['list'][7]['data'] };
  cupcakeShadow!: Sprite;
  cupcake!: Sprite & { data: typeof raw['list'][9]['data'] };
  gingerbreadShadow!: Sprite;
  gingerbread!: Sprite & { data: typeof raw['list'][11]['data'] };
  lollipopShadow!: Sprite;
  lollipop!: Sprite & { data: typeof raw['list'][13]['data'] };
  lollipop2Shadow!: Sprite;
  lollipop2!: Sprite & { data: typeof raw['list'][15]['data'] };
  puddingShadow!: Sprite;
  pudding!: Sprite & { data: typeof raw['list'][17]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
